import type { TimeRange } from "../utils/timerange";
import { TIME_RANGE_LABELS } from "../utils/timerange";

export enum RankingOrder {
  BestFirst = "bestFirst",
  WorstFirst = "worstFirst",
}

export const RANKING_ORDERS = Object.values(RankingOrder);

export type RankingTimeframe = TimeRange;

export type RankingResultCount = 3 | 5 | 10 | 20;

export const DEFAULT_RANKING_COUNT: RankingResultCount = 5;
export const RANKING_RESULT_COUNT_OPTIONS: RankingResultCount[] = [3, 5, 10, 20];

const RANKING_TIMEFRAME_KEYS = ["today", "thisWeek", "last7Days", "last30Days", "last90Days", "allTime"] as const;

export const RANKING_TIMEFRAME_OPTIONS: { value: RankingTimeframe; label: string }[] =
  RANKING_TIMEFRAME_KEYS.map((value) => ({ value, label: TIME_RANGE_LABELS[value] }));

export const ALL_AGENTS = "all";

export const RANKING_SUBMIT_LABELS: Record<RankingOrder, string> = {
  [RankingOrder.BestFirst]: "Find Great Examples",
  [RankingOrder.WorstFirst]: "Surface Anti-Patterns",
};
